module.exports = __webpack_public_path__ + "static/media/manage-proposal-requests.7ab589f1.svg";